<script>
export default {
  name: 'ItineraryDayProgramHotelModal',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    dayProgram: {
      type: Object,
      default: () => {},
    },
    selectedHotels: {
      type: Array,
      default: () => [],
    },
    availableHotels: {
      type: Array,
      default: () => [],
    },
    itineraryId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      toggled: true,
      available: [],
      selected: [],
      search: '',
      headers: [
        { text: this.$t('itinerary.hotelModal.table.name'), value: 'name' },
      ],
      pagination: {
        rowsPerPage: 10,
        descending: false,
        sortBy: 'name',
      },
    };
  },
  methods: {
    add(event) {
      const selected = [...this.selected];
      const available = [...this.available];
      const index = this.available.findIndex(item => item.id === event.id);
      selected.push(event);
      available.splice(index, 1);
      this.available = available;
      this.selected = selected;
    },
    remove(event) {
      const selected = [...this.selected];
      const available = [...this.available];
      const hotel = selected.splice(event, 1);
      available.push(hotel[0]);
      this.available = available;
      this.selected = selected;
    },
    update() {
      this.$emit('update', {
        itineraryId: this.itineraryId,
        dayProgramId: this.dayProgram.id,
        siteIds: this.selected.map(hotel => hotel.id),
      });
    },
  },
  watch: {
    loading(value) {
      if (!value) {
        this.selected = this.selectedHotels;
        this.available = this.availableHotels;
      }
    },
    toggled(value) {
      if (!value) {
        this.$emit('cancel');
      }
    },
  },
};
</script>

<template>
  <v-dialog
    v-model="toggled"
    max-width="800px"
  >
    <v-card>
      <v-flex font-weight-bold pa-3 title>
        <v-icon>hotel</v-icon>
        {{ $t('itinerary.hotelModal.title') }}
      </v-flex>
      <v-divider light/>
      <v-layout row wrap>
        <v-progress-linear
          class="my-0"
          v-if="loading"
          :active="loading"
          :indeterminate="true"
          :height="4"
        />
        <v-flex
          v-if="selected.length"
          sm12
          pa-3
        >
          <v-chip
            v-for="(hotel, index) in selected"
            :key="`selected-hotels__${index}`"
            close
            color="teal"
            text-color="white"
            @input="remove(index)"
          >
            <span>
              <strong>{{ hotel.name }}</strong>
            </span>
          </v-chip>
        </v-flex>
        <v-flex
          v-else
          sm12
          pa-3
          text-xs-center
          class="no-hotels"
        >
          <i>{{ $t('itinerary.hotelModal.noHotels') }}</i>
        </v-flex>
        <v-flex sm12>
          <v-text-field
            v-model="search"
            :loading="loading"
            :label="$t('inputs.placeholders.search')"
            class="px-4"
            clearable
            clear-icon="clear"
            append-icon="search"
          />
        </v-flex>
        <v-flex sm12>
          <v-data-table
            class="elevation-1"
            item-key="id"
            :headers="headers"
            :items="available"
            :pagination.sync="pagination"
            :loading="loading"
            :search="search"
            :no-data-text="$t('itinerary.hotelModal.noData')"
          >
            <template v-slot:items="props">
              <tr
                class="table-row"
                @click="add(props.item)"
              >
                <td>{{ props.item.name }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-layout justify-end>
        <v-btn
          color="red darken-1"
          flat
          @click="toggled = false"
        >
          {{ $t('inputs.actions.cancel') }}
        </v-btn>
        <v-btn
          :disabled="availableHotels === available || loading"
          :loading="loading"
          color="blue darken-1"
          flat
          @click="update"
        >
          {{ $t('inputs.actions.save') }}
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<style scoped>
  .table-row {
    cursor: pointer;
  }
  .no-hotels {
    color: #a6a6a6;
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryDayProgramHotelModal.vue